<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-cause" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :disabled="isView"
      id="form-visitors-category"
      class="show-tick form-control"
      @change="$emit('change-visitors-category')"
    >
      <option v-for="category in items" :key="category.id" :value="Number(category.id)" :title="category.name">
        {{ category.name }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import passSectionMixin from '@/common/mixins/application-form/passSectionMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'VisitorsCategoryInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin
  ],

  props: {
    inputLabel: {
      default: 'Категория посетителей'
    },

    inputName: {
      default: 'visitorsCategory'
    },

    inputHint: {
      default: undefined
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  }
}
</script>
